import React from "react";

const VmsOverview = ({category, type, selectedModule}) => {
  if (selectedModule === "bs") {
    return (
        <div className="mt-3">
          <p>This feature is not available for Bench Sales. However, you can configure the following features:</p>
          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Available Features for Bench Sales:</h6>
            <p>1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt; Kult AI (Text) &gt; Setup / Configure</p>
            <p>2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt; Apollo &gt; Setup / Configure</p>
            <p>3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt; G-Suite &gt; Setup / Configure</p>
            <p>4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt; Outlook &gt; Setup / Configure</p>
          </div>
        </div>
      );
  }
  
  return (
    <div className="border border-gray-200 rounded-md shadow-sm p-4 mt-8 bg-white">
      <h2 className="text-lg  text-orange-600  ">Details</h2>

      <div className="overflow-y-auto pr-12 ">
        <p className="text-sm text-gray-700">
          Sap Fieldglass is a cloud-based, open Vendor Management System (VMS)
          that helps organizations find, engage, manage, pay and unlock more
          value from this growing external workforce - anywhere in the world.
        </p>
        <p className="text-sm text-gray-700 mb-2">
          The Integration allows you to easily manage your global talent and
          partners to stay ahead of the competition.
        </p>

        <h3 className="text-xl text-gray-800 mb-2">Steps to Connect</h3>
        <ol className="list-decimal list-inside text-sm text-gray-700 space-y-3">
          <li>Click on the Configure Tab.</li>
          <li>Select VMS.</li>
          <li>Enter Username, password and client url.</li>
          <li>Seelct status, job hiring type, customer and recruiters.</li>
          <li>Enter customer-wise recruiter mapping fields.</li>
        </ol>
      </div>
    </div>
  );
};

export default VmsOverview;
